import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const LinkedPolygon = ({svgRef, points}) => { 
    let {x1,x2,y1,y2,height1,width1,height2,width2} = points;
    if (svgRef.current) {
        let rect = svgRef.current.getBoundingClientRect();
        x1 -= rect.left
        x2 -= rect.left;
        y1 -= rect.top;
        y2 -= rect.top;
    }

    return (
        <polygon points={[
            x1,y1,
            x2,y2,
            x2+width2,y2,
            x1+width1,y1]}/>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkedPolygon);
